import React, { useEffect, useMemo, useState } from "react";
import { Search, Package, Wrench, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { listCatalog } from "../lib/api";
import { fmtPrice } from "./Catalog";

// Picks a catalog item → quote line {description, quantity, unit_price, no_price, catalog_id}
export default function CatalogPicker({ open, onClose, companyId, onPick }) {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { if (open && companyId) { setQ(""); listCatalog(companyId).then((d) => setItems(d.items)).catch(() => setItems([])); } }, [open, companyId]);
  const filtered = useMemo(() => {
    const nq = q.trim().toLowerCase();
    return (items || []).filter((i) => !nq || `${i.name} ${i.description || ""} ${i.category || ""}`.toLowerCase().includes(nq));
  }, [items, q]);

  const pick = (it) => {
    onPick({ description: it.description ? `${it.name}\n${it.description}` : it.name, quantity: 1, unit_price: it.price ?? 0, no_price: false, catalog_id: it.id });
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-3xl p-0 overflow-hidden" data-testid="catalog-picker">
        <DialogHeader className="px-5 pt-5 pb-3">
          <DialogTitle className="text-[16px]">Adicionar do catálogo</DialogTitle>
          <DialogDescription className="text-[12.5px]">Itens sem preço entram com valor em branco para você preencher.</DialogDescription>
        </DialogHeader>
        <div className="px-5 pb-3">
          <div className="relative">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar…" data-testid="catalog-picker-search" className="w-full h-9 rounded-full bg-slate-50 ring-1 ring-slate-200 focus:ring-2 focus:ring-slate-900 pl-9 pr-3 text-[13px] outline-none" />
          </div>
        </div>
        <div className="max-h-[50vh] overflow-y-auto px-2 pb-3">
          {items === null ? <p className="px-3 py-6 text-center text-[12.5px] text-slate-400">Carregando…</p>
            : !items.length ? <p className="px-3 py-6 text-center text-[12.5px] text-slate-400" data-testid="catalog-picker-empty">Seu catálogo ainda está vazio. Cadastre itens na aba Catálogo.</p>
            : !filtered.length ? <p className="px-3 py-6 text-center text-[12.5px] text-slate-400">Nada encontrado.</p>
            : filtered.map((it) => (
              <button key={it.id} onClick={() => pick(it)} data-testid={`catalog-pick-${it.id}`} className="w-full flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-slate-50 text-left transition-colors">
                <span className="w-10 h-10 shrink-0 rounded-lg overflow-hidden bg-slate-100 grid place-items-center text-slate-300">{it.image ? <img src={it.image} alt="" className="w-full h-full object-cover" /> : it.kind === "product" ? <Package size={16} /> : <Wrench size={16} />}</span>
                <span className="flex-1 min-w-0">
                  <span className="block text-[13.5px] font-medium text-slate-900 truncate">{it.name}</span>
                  {it.description && <span className="block text-[11.5px] text-slate-500 truncate">{it.description}</span>}
                </span>
                <span className={`text-[12.5px] shrink-0 ${it.price == null ? "text-slate-400" : "font-semibold text-slate-800"}`}>{fmtPrice(it.price, it.unit)}</span>
                <Plus size={14} className="text-slate-400 shrink-0" />
              </button>
            ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
